/* The empty collection's rescue rail.
 *
 * 921 of the store's 974 collections hold no products. Searching the
 * collection's own name works where the collection does not, so an empty
 * collection runs that search and shows what comes back.
 *
 * Liquid cannot run a search outside the search template, so this asks
 * Shopify's own predictive search endpoint, which is the same index the search
 * page uses and answers with the fields a card needs.
 *
 * The rail ships hidden and is revealed only when something comes back. A
 * collection that is empty AND whose name finds nothing shows the message and
 * the search button alone, which is still true and still useful, rather than an
 * empty labelled rail promising results that are not there.
 *
 * These are search results and the markup says so. They are not the collection's
 * contents and must never be presented as though they were.
 */
(function () {
  var rail = document.querySelector('[data-aps-alt]');
  if (!rail) return;

  var term = rail.getAttribute('data-aps-alt-term');
  if (!term) return;
  var grid = rail.querySelector('[data-aps-alt-grid]');
  if (!grid) return;

  var LIMIT = 4;
  var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
    '&resources[type]=product&resources[limit]=' + LIMIT;

  /* Money comes back as a plain decimal string. The cents are raised to match
     the card in the grid, and anything that is not a simple amount is printed
     whole rather than guessed at. */
  function price(value) {
    var parts = String(value == null ? '' : value).split('.');
    if (parts.length !== 2) return '<span class="now">' + esc(value) + '</span>';
    var dollars = Number(parts[0]).toLocaleString();
    return '<span class="now"><span class="aps-pn">$' + dollars + '<sup>' + parts[1] + '</sup></span></span>';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function card(p) {
    var img = p.featured_image && p.featured_image.url
      ? '<img src="' + esc(p.featured_image.url) + '" alt="" width="210" height="210" loading="lazy">'
      : '';
    var sale = '';
    /* Same rule the server card follows: a compare at equal to the price is not
       a sale, so only a strictly higher one draws anything. */
    var now = parseFloat(p.price);
    var was = parseFloat(p.compare_at_price);
    if (was > now) {
      var pct = Math.round(((was - now) / was) * 100);
      sale = '<span class="flag">' + pct + '% off</span>';
    }
    return '<article class="pc">' + sale +
      '<div class="im">' + img + '</div>' +
      (p.vendor ? '<div class="bd">' + esc(p.vendor) + '</div>' : '') +
      '<a class="ti" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<div class="pz">' + price(p.price) + '</div>' +
      '</article>';
  }

  fetch(url, { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      var items = data && data.resources && data.resources.results &&
        data.resources.results.products;
      if (!items || !items.length) return;
      grid.innerHTML = items.slice(0, LIMIT).map(card).join('');
      rail.hidden = false;
    })
    .catch(function () { /* The message and the search button stand on their own. */ });
}());
